import React from 'react';
import { useDispatch } from 'react-redux';
import { makeStyles } from '@material-ui/core/styles';

import {
    Paper,
    Table,
    Button,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow, Typography
} from '@material-ui/core';


import Swal from 'sweetalert2';

import {toastConfig} from '@/services/utils/swalHelper';
import { formatDate } from '@/services/utils/date-time';
import { apiClient } from '@/api/client';
import { fetchReservationDetails } from '@/redux/actions/Reservation';

type columnType = { id: string, minWidth: number, label: string, align?: 'right' | 'left' | 'inherit' | 'center' | 'justify', format?: any };

const columns: columnType[] = [
    {
        id: 'action',
        label: 'Name',
        minWidth: 170,
        align: 'left',
    },
    {
        id: 'type',
        label: 'Type',
        minWidth: 70,
        align: 'center',
    },
    {
        id: 'status',
        label: 'Status',
        minWidth: 100,
        align: 'center',
    },
    {
        id: 'expectedSendOutDate',
        label: 'Delivery Date',
        minWidth: 170,
        align: 'center',
        format: (date: string) => formatDate(date, 'yyyy/MM/dd - HH:mm')
    },
    {
        id: 'actualSendOutDestination',
        label: 'Destination',
        minWidth: 200,
        align: 'center',
    },
    {
        id: 'createdAt',
        label: 'Created',
        minWidth: 170,
        align: 'center',
        format: (date: string) => formatDate(date, 'yyyy/MM/dd - HH:mm')
    },
    {
        id: 'resendButton',
        label: '',
        minWidth: 100,
        align: 'right',
    }
];

type notificationType = {
    action: string,
    type: 'email' | 'sms' | 'whatsapp',
    status: string,
    reservationId: string,
    customerId: string,
    expectedSendOutDate: string,
    actualSendOutDate: string,
    actualSendOutDestination: string,
    createdAt: string,
    updatedAt: string,
};

const useStyles = makeStyles(() => ({
    root: {
        marginTop: '10px',
        width: '100%',
    },
}));

export default function Notifications({ messages, reservationId }: { messages: notificationType[], reservationId: string }) {
    messages = messages.sort((a, b) => new Date(b.expectedSendOutDate).getTime() - new Date(a.expectedSendOutDate).getTime())

    const classes = useStyles();
    const dispatch = useDispatch();

    const resendNotification = async (notification: notificationType) => {
        const choice = await Swal.fire({
            icon: 'question',
            title: 'Are you sure?',
            text: `Re-send ${notification.type} notification for "${notification.action}"`,
            showCancelButton: true
        });
        if (choice.isDismissed) {
            return;
        }

        try {
            Swal.fire({
                icon: 'info',
                title: `Sending ${notification.type} "${notification.action}"`,
                text: 'Hang thight, gonna take a sec...',
            });

            await apiClient.notification.sendNotification({
                type: notification.type,
                action: notification.action,
                reservationId: notification.reservationId,
                customerId: notification.customerId,
            });

            // Wait a sec before refetching reservation details
            await new Promise((resolve) => setTimeout(resolve, 3000))
            dispatch(fetchReservationDetails(reservationId));

            Swal.fire({
                icon: 'success',
                text: 'Notification re-sent successfully',
                ...toastConfig()
            });
        } catch (error) {
            Swal.fire({
                icon: 'error',
                title: 'Something wrong happened',
                text: 'It looks like something has gone wrong'
            });
        }
    };

    const getResendButton = (notification: notificationType) => (
        <Button
            onClick={() => resendNotification(notification)}
            variant="outlined"
            size="small"
        >
            <Typography>Resend</Typography>
        </Button>
    );

    return (
        <Paper className={classes.root}>
            <TableContainer>
                <Table stickyHeader aria-label="table">
                    <TableHead>
                        <TableRow>
                            {columns.map((column: columnType) => (
                                <TableCell
                                    key={column.id}
                                    align={column.align}
                                    style={{ minWidth: column.minWidth }}
                                >
                                    <Typography>{column.label}</Typography>
                                </TableCell>
                            ))}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {messages.map((notification: notificationType, index: number) => {
                            return (
                                <TableRow hover role="checkbox" tabIndex={-1} key={index}>
                                    {columns.map((column: columnType) => {

                                        // @ts-ignore strong typings needs to be added
                                        const value = column.id === 'resendButton' ? getResendButton(notification) : notification[column.id];

                                        return (
                                            <TableCell key={column.id} align={column.align}>
                                                <Typography>
                                                    {
                                                        column.format && value ? column.format(value) : value || '-'
                                                    }
                                                </Typography>
                                            </TableCell>
                                        );
                                    })}
                                </TableRow>
                            );
                        })}
                    </TableBody>
                </Table>
            </TableContainer>
        </Paper>
    );
}
